import React from "react"
import PropTypes from "prop-types"
import { Display, Headline, Subheading } from "ui-Text"
import Hidden from "@material-ui/core/Hidden"
import { Container } from "ui-Grid"

export default function HeroTitle({ subTitle, title, wide, narrow }) {
  if (!title) {
    return null
  }

  return (
    <Container wide={wide} narrow={narrow} position="relative">
      <Hidden xsDown>
        <Display level={3} color="inherit">
          {title}
        </Display>
        {subTitle && (
          <Headline paragraph component="div">
            {subTitle}
          </Headline>
        )}
      </Hidden>
      <Hidden smUp>
        <Display color="inherit" paragraph>
          {title}
        </Display>
        {subTitle && (
          <Subheading paragraph component="div">
            {subTitle}
          </Subheading>
        )}
      </Hidden>
    </Container>
  )
}

HeroTitle.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  wide: PropTypes.bool,
  narrow: PropTypes.bool,
}

HeroTitle.defaultProps = {
  wide: true,
  narrow: false,
}



// WEBPACK FOOTER //
// ./src/components/ui-HeroTitle/index.js